const STAFF_TOKEN_KEY = 'san_gao_staff_token';
const STAFF_INFO_KEY = 'san_gao_staff_info';

// 版本标记只负责页面入口；实际机构和登录权限由后端校验。
export function isTaikangStaffMode(query) {
  return !!query && String(query.taikang) === '1';
}

export function isTaikangStaffSession() {
  if (!localStorage.getItem(STAFF_TOKEN_KEY)) return false;
  try {
    const info = JSON.parse(localStorage.getItem(STAFF_INFO_KEY) || 'null');
    return !!info && info.taikangMode === true;
  } catch (error) {
    return false;
  }
}
